import { render, staticRenderFns } from "./_DisposalRecyclingNoteDialog.vue?vue&type=template&id=3ff94330&scoped=true&"
import script from "./_DisposalRecyclingNoteDialog.vue?vue&type=script&lang=js&"
export * from "./_DisposalRecyclingNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff94330",
  null
  
)

export default component.exports